import type { ErrorInfo } from 'react'
import { captureException } from './error-reporting'

type RootErrorHandler = (error: unknown, errorInfo: ErrorInfo) => void

/**
 * React 19 root error callbacks (createRoot options). React stops reporting to
 * `window.onerror` once these are set, so posthog-js's native capture never
 * sees them: report here, with the component stack, then run `callback`.
 */
export function reactErrorHandler(
  mechanism: string,
  callback?: RootErrorHandler
): RootErrorHandler {
  return (error, errorInfo) => {
    captureException(
      error,
      {
        extra: errorInfo.componentStack ? { componentStack: errorInfo.componentStack } : undefined,
      },
      mechanism
    )
    callback?.(error, errorInfo)
  }
}
